import {inject} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateFn } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

/** Reset authentication and redirect user to login page */
const resetAuthentication = (params: any): void => {
  const router = inject(Router);
  localStorage.removeItem('IV-TOKEN');
  localStorage.removeItem('IV-PROFILE');

  router.navigate(['/login'], { queryParams: { url: encodeURI(params) } });
}

/** Check user's session is not exist and not expired */
export const canActivateAuthGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {

  const jwtHelper: JwtHelperService = new JwtHelperService();
  // try {
    const token = localStorage.getItem('IV-TOKEN');
    if (token != null) {
      if (jwtHelper.isTokenExpired(token)) {
        resetAuthentication(state.url);
        return false;
      } else {
        return true;
      }
    } else {
      resetAuthentication(state.url);
      return false;
    }
  /*} catch (ex) {
    resetAuthentication(state.url);
    return false;
  }*/
}
